export const getCognitoLoginLink = () => {
    const base = process.env.NEXT_PUBLIC_COGNITO_DOMAIN!
    const clientId = process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID!
    const redirectUri = process.env.NEXT_PUBLIC_REDIRECT_URI!

    const cognitoLoginUrl =
        `${base}/oauth2/authorize` +
        `?client_id=${clientId}` +
        `&response_type=code` +
        `&redirect_uri=${encodeURIComponent(redirectUri)}&lang=ja`

    return cognitoLoginUrl
}

export const getRedirectUri = () => {
    return process.env.NEXT_PUBLIC_REDIRECT_URI!
}

export function cognitoLogout() {
    const redirectUri = process.env.NEXT_PUBLIC_REDIRECT_URI_LOGOUT!
    const logoutUrl = `${process.env.NEXT_PUBLIC_COGNITO_DOMAIN}/logout?client_id=${process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(redirectUri)}`;
    window.location.href = logoutUrl;
}